<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-row>
        <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">พิมพ์บราโค๊ดติดชั้น</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
      </v-row>

      <v-row>

        <!-- รายการสินค้า -->
        <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
          <v-card elevation="4" style="border-radius: 15px;">
            <v-card-title class="d-flex justify-space-between">
              <div>
                <h1 style="color: #616A6B; font-size: 20px; font-weight: 600;">
                  รายการสินค้า
                </h1>
              </div>
              <div></div>
            </v-card-title>
            <v-card-title class="d-flex justify-space-between">
              <div>
                <v-tabs v-model="tabs" color="#D6BFAF">
                  <v-tab @click="Tabs(0)">รายการสินค้า</v-tab>
                  <v-tab @click="Tabs(1)">รายการสินค้าใกล้หมดอายุ</v-tab>
                </v-tabs>
              </div>
              <div>
                <v-text-field color="#D6BFAF" class="input-radius inp-text-field" append-icon="mdi-magnify"
                  hide-details="auto" required v-model="search" placeholder="ค้นหา..." single-line outlined
                  dense></v-text-field>
              </div>
            </v-card-title>

            <v-card-text>
              <v-data-table v-if="loading_table" v-model="selected" :headers="headers" :items="desserts"
                mobile-breakpoint="0" :hide-default-footer="true" show-select>
                <!-- <template v-slot:header.data-table-select="{ on, props }">
                  <v-simple-checkbox color="#D6BFAF" v-bind="props" v-on="on" @click="onSelectAll()" />
                </template> -->
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="(item) in items" :key="item.id">
                      <td class="hidden_line"><v-checkbox color="#D6BFAF" v-model="selected" :value="item" /></td>
                      <td class="hidden_line">{{ item.barcode }}</td>
                      <td class="hidden_line" style="width: 220px;">{{ item.product_name }}</td>
                      <td class="hidden_line">{{ item.unit_name }}</td>
                      <td class="hidden_line">{{ formatPrice(item.price_standard) }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
              <v-pagination class="justify-end" v-model="page" :length="page_all" :total-visible="7"
                color="#D6BFAF"></v-pagination>
            </v-card-text>

          </v-card>
        </v-col>

        <!-- ตั้งค่าการพิมพ์ -->
        <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
          <v-card elevation="4" style="border-radius: 15px;">
            <v-card-title>
              <h1 style="color: #616A6B; font-size: 20px; font-weight: 600;">ตั้งค่าการพิมพ์</h1>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col xs="12" sm="6" md="6" lg="6" xl="6" cols="6">
                  <label class="label_form_text">กระดาษ <span class="required--text">*</span></label>
                  <v-autocomplete color="#D6BFAF" class="input-radius" v-model="select_paper_size" :items="paper_size" item-text="size"
                    item-value="id" hide-details="auto" placeholder="กรุณาเลือกขนาดกระดาษ" single-line outlined
                    :rules="[v => !!v || 'กรุณาเลือกข้อมูล']" clearable prepend-inner-icon="mdi-file"
                    dense></v-autocomplete>
                </v-col>
                <v-col xs="12" sm="6" md="6" lg="6" xl="6" cols="6">
                  <label class="label_form_text">จำนวนที่ต้องการพิมพ์ต่อสินค้า <span
                      class="required--text">*</span></label>
                  <v-text-field color="#D6BFAF" clearable class="input_width" :rules="[v => !!v || 'กรุณากรอกข้อมูล']" ref="quantity_printed" v-model="quantity_printed"
                    @input="genbarcode" prepend-inner-icon="mdi-barcode-scan"
                    hide-details="auto" outlined dense></v-text-field>
                </v-col>

                <!-- ตัวอย่างก่อนพิมพ์ -->
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="d-flex justify-space-between">
                    <h1 style="color: #616A6B; font-size: 20px; font-weight: 600;">ตัวอย่างก่อนพิมพ์</h1>
                    <div>
                      <v-checkbox class="ma-0" color="#D6BFAF" v-model="print_before" :value="print_before"
                        label="แสดงเส้นประ" hide-details="auto" />
                    </div>
                  </div>
                </v-col>

                <v-col xs="12" id="barcode-page" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-card elevation="4" class="pa-3 card_relative grid_four_ck" min-height="500px">
                    <v-row v-if="tabs == 0"  class="pa-3">
                      <v-col v-for="(item, index) in repeatNumbers(selected_data, quantity_printed)" :key="index"
                        style="max-width: fit-content !important;">
                        <div class="d-flex flex-column pa-2"
                          style="border: 1px solid #d9d9d9; gap:5px; width: 189px; height: 113.4px;">
                          <div style="line-height:15px ">
                            <p class="ma-0 fs-12 fw-500 line-2" style="line-height: 1.2; min-height: 25px;">
                              {{ item.product_name }}
                            </p>
                            <div class="d-flex justify-space-between">
                              <span class="fs-8 fw-500">T-{{ item.product_type }}</span>
                              <span class="fs-8 fw-500">{{ item.product_code }}</span>
                            </div>
                          </div>
                          <div class="d-flex" style="gap: 4px;line-height:15px ">
                            <h1 class="fs-24 fw-700">{{ formatPrice(item.price_standard) }}</h1>
                            <span class="fs-10 fw-400" style="position: relative; bottom: -4px;">ราคาลูกค้าทั่วไป</span>
                          </div>
                          <div class="d-flex justify-space-between">
                            <div class="d-flex align-end" style="padding-bottom: 8px;">
                              <div>
                                <p class="ma-0 fs-10 fw-400">ราคาลูกค้าสมาชิก</p>
                                <h4 class="fs-14 fw-600 lh-1">{{ formatPrice(item.price_register) }}</h4>
                              </div>
                            </div>
                            <div class="text-center">
                              <svg ref="barcodeCanvas" :id="'barcodeCanvas_' + index" width="70px" height="32px"></svg>
                            </div>
                          </div>
                        </div>
                        <div v-if="(index + 1) % 21 === 0" class="pagebreak"></div>
                      </v-col>
                    </v-row>
                    <v-row v-else class="pa-3">
                      <!-- SALE -->
                      <v-col v-for="(item, index) in repeatNumbers(selected_data, quantity_printed)" :key="index"
                        style="max-width: fit-content !important;">
                        <div class="d-flex flex-column"
                          style="border: 1px solid #d9d9d9; width: 189px; height: 113.4px;">
                          <div class="pa-2 d-flex justify-center align-item-center"
                            style="background: #CF081D; width: 50%; border-radius: 0 0 15px 0;">
                            <h1 class="fs-24 fw-700" style="color: #fff;">SALE</h1>
                          </div>
                          <div style="line-height:15px; ">
                            <div class="d-flex justify-space-between">
                              <div class="pa-2">
                                <p class="ma-0 fs-10 fw-500 lh-2 line-2" style="line-height: 1.5; min-height: 32px;">
                                  {{ item.product_name }}
                                </p>
                              </div>
                              <div class="d-flex flex-column align-center" style="padding-right: 16px;line-height:15px">
                                <h1 class="fs-24 fw-700">{{ formatPrice(item.price_standard) }}</h1>
                                <h3 class="fs-14 fw-400"><del>{{ formatPrice(item.price_retail) }}</del></h3>
                              </div>
                            </div>
                            <div class="d-flex justify-space-between mt-3" style="padding-left: 8px; padding-right: 8px;line-height:15px">
                              <div class="d-flex align-end" style="padding-bottom: 8px;">
                                <div>
                                  <div class="lh-1">
                                    <span class="fs-8 fw-500 lh-1" style="margin-right: 8px;">T-{{ item.product_type
                                    }}</span>
                                    <span class="fs-8 fw-500 lh-1">{{ item.product_code }}</span>
                                  </div>
                                  <!-- <div class="lh-1">
                                    <span class="fs-8 fw-500 lh-1">02/04/2023</span>
                                    <span class="fs-8 fw-500 lh-1"> - </span>
                                    <span class="fs-8 fw-500 lh-1">30/04/2023</span>
                                  </div> -->
                                </div>
                              </div>
                              <div class="text-center">
                                <svg ref="barcodeCanvas" :id="'barcodeCanvas_' + index" width="70px" height="32px"></svg>
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="title_page ma-3" style="justify-content:center;">
                    <v-btn type="button" class="btn_print_barcode" @click="print()" elevation="4" large>พิมพ์</v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

        </v-col>
      </v-row>

    </div>
  </div>
</template>
<script>
// import cancel_order from "@/assets/arin_assets/cancel_order.png";
import { HTTP_ARIN } from "@/axios_arin";
// import Swal from "sweetalert2";
// import { taxNumber } from "@/js/handler";
import JsBarcode from 'jsbarcode'
import { formatPrice } from "@/js/numberformats";
// JsBarcode(".barcode").init();
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Print_barcode_onshelf",
  data() {

    return {
      tabs: 0,
      loading_table: false,
      loading_page: false,
      search: '',
      searchTimer: null,
      page: 1,
      page_all: 1,
      input_set: [],
      type_api: 0,
      selected: [],
      selected_all: [],
      selected_data: [],
      headers: [
        {
          text: 'บาร์โค้ด',
          value: 'barcode',
          fixed: true,
          width: '100px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'product_code',
          fixed: true,
          width: '20px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit',
          fixed: true,
          sortable: false,
          width: '20px',
        },
        {
          text: 'ราคาขาย',
          value: 'price',
          fixed: true,
          sortable: false,
          width: '20px',
        },
      ],
      desserts: [],
      sub_menu: [
        {
          text: 'ระบบ POS',
          disabled: false,
        },
        {
          text: 'คลังสินค้า',
          disabled: false,
        },
        {
          text: 'พิมพ์บราโค๊ดติดชั้น',
          disabled: false,
          href: '#',
        },
      ],
      select_paper_size: 1,
      paper_size: [
        { id: 1, size: 'A4' },
        { id: 2, size: 'กระดาษปริ้นบาร์โค๊ด' }
      ],
      quantity_printed: 1,
    }
  },
  methods: {
    genbarcode() {
      this.repeatNumbers(this.selected_data, this.quantity_printed).forEach((product, index) => {
        this.$nextTick(() => {
          const canvas = this.$refs['barcodeCanvas'][index];
          JsBarcode(canvas, product.barcode, {
            format: 'CODE128',
            displayValue: true,
            width: 0.55,
            height: 20,
            fontSize: 10,
            margin: 0
          });
        });
      });
    },

    repeatNumbers(arr, times) {
      let result = [];
      for (let i = 1; i <= times; i++) {
        for (let j = 0; j < arr.length; j++) {
          result.push(arr[j]);
        }
      }
      return result;
    },

    formatPrice(evt) {
      return formatPrice(evt)
    },

    // GET ข้อมูล
    getProductList() {
      this.loading_table = false;
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get(`/product/get/productlist?page=${this.page}&search=${this.search}`, config).then(async (res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          this.desserts = await res.data.productList;
          this.page = parseInt(res.data.current_page ? res.data.current_page : 1);
          this.page_all = res.data.count_page ? res.data.count_page : 1;
          this.loading_table = true;
        }
      })
    },
    // GET ข้อมูล
    getProductExpiredList() {
      this.loading_table = false;
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get(`/pos/storage/product/expired/barcode/list/print?page=${this.page}&search=${this.search}`, config).then(async (res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          this.desserts = await res.data.productList;
          this.page = parseInt(res.data.current_page ? res.data.current_page : 1);
          this.page_all = res.data.count_page ? res.data.count_page : 1;
          this.loading_table = true;
        }
      })
    },

    Tabs(tab) {
      this.tabs = 1;
      this.page = 1;
      this.selected = [];
      this.selected_data = [];

      if (tab == 1) {
        this.getProductExpiredList();
      } else {
        this.getProductList();
      }
    },

    async print() {
      if(this.$refs.quantity_printed.validate()){
        this.$nextTick(() => {
                    // Your HTML content
          var divContents = document.getElementById("barcode-page").innerHTML;

          // Your CSS styles
          var cssStyles = `
            @import url('https://fonts.googleapis.com/css2?family=Kanit:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
            *{
              padding: 0;
              margin: 0;
              font-family: "Kanit", sans-serif;
            }
            .row {
              display: flex;
              flex-wrap: wrap;
              flex: 1 1 auto;
              margin: -12px;
            }
            .pa-3 {
              padding: 12px !important;
            }
            .pa-2 {
              padding: 8px !important;
            }
            .flex-column {
              flex-direction: column !important;
            }
            .d-flex {
              display: flex !important;
            }
            .justify-space-between {
              justify-content: space-between !important;
            }
            .align-end {
              align-items: flex-end !important;
            }
            .text-center {
              text-align: center !important;
            }
            .col {
              flex-basis: 0;
              flex-grow: 1;
              max-width: 100%;
              width: 100%;
              padding: 5px;
            }
            .fw-700 {
              font-weight: 700;
            }
            .fw-400 {
              font-weight: 400;
            }
            .fs-10 {
              font-size: 10px;
            }
            .fs-24 {
              font-size: 24px;
            }
            .fs-12 {
              font-size: 12px;
            }
            .fs-8 {
              font-size: 8px;
            }
            .fw-500 {
              font-weight: 500;
            }
            .line-2 {
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: normal;
              /* height: 53px; */
              text-wrap: wrap;
            }
            .ma-0 {
              margin: 0px !important;
            }
            .lh-1 {
              line-height: 1;
            }

            @media print {
              .pagebreak { page-break-before: always; } /* page-break-after works, as well */
            }
            @page {
              size: A4; /* Set the paper size, e.g., A4 */
              margin: 2px;
              margin-top: 16px;
            }
          `;

          // Open a new window
          var a = window.open("", "", "height=700, width=500");
          a.document.write("<html>");
          a.document.write("<head>");
          a.document.write("<style>");
          // Add the CSS styles to the new window
          a.document.write(cssStyles);
          a.document.write("</style>");
          a.document.write("</head>");
          a.document.write("<body>");
          a.document.write(divContents);
          a.document.write("</body></html>");
          a.document.close();
          a.print();

          // Clear selected items after print
          this.selected = [];
          this.selected_data = [];
        });

      }
    },
  }
  ,
  mounted() {
    this.getProductList()
  },
  watch: {
    async selected() {
      this.selected_data.splice(0);
      await this.selected_data.push(...this.selected);
      this.genbarcode()
    },
    // selected() {
    //   this.genbarcode()
    // },
    page() {
      this.getProductList()
    },
    search() {
      this.loading_table = false;
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(async () => {
        this.page = 1;
        this.search  = this.search.replace(/,/g, '');
        if (this.tabs == 1) {
          await this.getProductExpiredList();
        } else {
          await this.getProductList();
        }
      }, 500);
    }
  }
}
</script>

<style scoped>
.line-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  /* height: 53px; */
  text-wrap: wrap;
}

.btn_print_barcode {
  width: 160px;
  border-radius: 10px;
  background: linear-gradient(90deg, #659264 0%, #88B358 100%), #88B358;
  color: #FFF;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.pa-40 {
  padding: 40px;
  padding-top: 10px;
  padding-bottom: 15px;
}

.line-grid {
  display: inline-grid;
}

.font-20 {
  font-size: 20px;
}

.fw-700 {
  font-weight: 700;
}

.fw-500 {
  font-weight: 500;
}

.fw-400 {
  font-weight: 400;
}

.fs-24 {
  font-size: 22px;
}

.fs-14 {
  font-size: 12px;
}

.fs-12 {
  font-size: 11px;
}

.fs-10 {
  font-size: 10px;
}

.fs-8 {
  font-size: 8px;
}

.fs-6 {
  font-size: 6px;
}

.lh-1 {
  line-height: 1;
}

.lh-2 {
  line-height: 1.2;
}

.title-flex-center {
  display: flex;
  align-items: center;
}

.title-flex-baseline {
  display: flex;
  align-items: baseline;
  font-size: 16px;
}

.title_page h4.breadcrumb_title_page {
  font-size: 20px !important;
}

.v-timeline::before {
  top: 55px;
  height: calc(100% - 80px);
}

.theme--light.v-timeline:before {
  background-color: #D6BFAF;
  width: 4px;
}

/* .header-content {
  margin-left: -15px;
  background: #f1e9e3;
  border: 1px solid #f1e9e3;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0 30px 30px 0;
  margin-top: 2px;
  margin-bottom: 2px;
} */

.v-tab {
  font-size: 16px;
  font-weight: 500;
}

.v-tab.v-tab--active {
  font-size: 16px;
  font-weight: 700;
}

.content-font {
  color: #616A6B;
  font-weight: 500;
  font-size: 16px;
}

.title_form_main {
  background: #D6BFAF;
  z-index: 2;
  border-radius: 50%;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
  height: 38px;
  left: calc(50% - 19px);
  width: 38px;
}

.title_form_header {
  background: #D6BFAF;
  padding: 4px 10px 4px 10px;
  /* opacity: 0.35; */
  border: 1px solid #D6BFAF;
  box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
  border-radius: 0px 30px 30px 0px;

}

.title_form_header_text {
  color: #616A6B;
}


.logo_timeline {
  padding: 6px;
}


.logo_timeline>img {
  max-width: 25px;
}

.text_title {
  color: #616A6B;
  font-weight: bold;
  font-size: 16px;
}

.grid_half {
  display: grid;
  grid-template-columns: 45% 55%;
}



.v-otp-input .v-input {
  padding: 10px !important
}

.input-radius {
  border-radius: 10px;
}

.grid_radio {
  display: flex;
  justify-content: space-around;
}

.btn_width {
  width: 50%;
}

.image_half {
  display: grid;
  grid-template-columns: 40% 60%;
}

.input_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.mobile_btn {
  width: 15%;
}

.file_input_style {
  position: absolute;
  top: 55px;
  left: 150px;
  right: 0;
  bottom: 0;
}

.preview {
  border-radius: 10px;
}

.preview.profile_img {
  max-width: 300px;
  border-radius: 30px;
}

.btn_edit_logo {
  border-radius: 10px;
  background-color: #FFF;
  position: absolute;
  top: 8px;
  right: 16px;
}


.logo_admin {
  width: 80px;
  height: 80px;
}

.logo_admin>img {
  max-width: 80px;
}

.btn_width {
  width: 50%;
}

.input-radius {
  border-radius: 10px;
}

.table-data-img-center {
  display: flex;

}

.v-data-table__wrapper>>>span {
  font-size: 50px;
}

.title_form {
  display: flex;
  margin-top: 2px;
}

label.label_form_text {
  font-size: 16px !important;
  color: #616A6B !important;
}

.btn_add_data {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
  border-radius: 10px;
  width: 40%;
}

@media only screen and (min-width: 0px)AND (max-width: 361px) {
  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 100%;
  }
}

@media only screen and (max-width: 600px) {

  .title_page h4.breadcrumb_title_page,
  .v-tab {
    font-size: 14px !important;
  }

  .v-timeline-item__divider {
    display: none !important;
  }

  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 100%;
  }
}

@media only screen and (min-width: 601px) AND (max-width: 960px) {
  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 50%;
  }
}

@media only screen and (min-width: 961px) AND (max-width: 1264px) {
  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 30%;
  }
}

@media only screen and (min-width: 1265px) AND (max-width: 1904px) {
  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 30%;
  }
}
</style>
